<!-- #Body -->
<div *transloco="let translated">
  <div class="modal-body">
    <div class="d-flex flex-column justify-content-center text-center">
      <div class="d-flex  justify-content-center mb-3">
        <span class="icon-stack fa-6x">
          <i class="base-4 icon-stack-3x color-success-500"></i>
          <i class="base-4 icon-stack-1x color-success-400"></i>
          <i class="ni ni-phone icon-stack-1x text-white"></i>
        </span>
      </div>
      <h2>
        <strong>
          <!-- {{ translated(this.LANUGAGE + '.submitEmailSuccessTitle')}} -->
          Chúc mừng! Số điện thoại của bạn đã được đổi thành công
        </strong>
      </h2>
      <h5>

      </h5>
    </div>
  </div>
  <!-- #Footer -->
  <div class="modal-footer justify-content-center border-top">
    <button class="btn btn-primary px-5" type="button" (click)="this.activeModal.dismiss(true)">
      <span>
        Tiếp tục sử dụng ứng dụng
      </span>
    </button>
  </div>
</div>
